import React from "react";

import "./styles.scss";
import { VacationRentalBookMobileButtonConnectorProps } from "./container";
import {
  ADD_TRAVELERS,
  ADD_CONTACT_INFO,
  APPLY_REWARDS,
  CONFIRM_AND_BOOK,
} from "./textConstants";
import { MobileFloatingButton } from "halifax";
import { Box } from "@material-ui/core";

export interface IVacationRentalBookMobileButtonProps
  extends VacationRentalBookMobileButtonConnectorProps {
  showPaymentStep: boolean;
  hasContactInfo?: boolean;
  isBookingValid: boolean;
  openContactInfo: () => void;
  onApplyRewards: () => void;
  onConfirmAndBook: () => void;
}

export const VacationRentalBookMobileButton = (
  props: IVacationRentalBookMobileButtonProps
) => {
  const {
    hasContactInfo,
    selectedTravelerId,
    openContactInfo,
    showPaymentStep,
    onApplyRewards,
    onConfirmAndBook,
    isBookingValid,
  } = props;


  const getButtonText = () => {
    if (!selectedTravelerId) {
      return ADD_TRAVELERS;
    } else if (!hasContactInfo) {
      return ADD_CONTACT_INFO;
    } else if (!showPaymentStep) {
      return APPLY_REWARDS;
    } else {
      return CONFIRM_AND_BOOK;
    }
  };
  const isDisabled = () => {
    return showPaymentStep && !isBookingValid;
  };
  const onClick = () => {
    if (!hasContactInfo) {
      openContactInfo();
    } else if (!showPaymentStep) {
      onApplyRewards();
    } else {
      onConfirmAndBook();
    }
  };

  if (isDisabled()) return null;

  return (
    <Box className="vacation-rental-book-mobile-button-container">
      <MobileFloatingButton
        className="vacation-rental-book-mobile-button"
        onClick={onClick}
        wrapperClassName="b2b"
      >
        {getButtonText()}
      </MobileFloatingButton>
    </Box>
  );
};
